import React from 'react'


export const ItemWrapperAccess = ({
    children
}) => (
    <article className="access-item">
        {children}
    </article>
)

export const ItemHeaderAccess = ({
    title,
    subTitle
}) => (
    <header className={"access-item-header" + (title || subTitle ? ' has-content' : '')}>
        {title && <h3 className="access-item-title title-xlarge-black access-typo" dangerouslySetInnerHTML={{ __html: title}}></h3>}
        {subTitle && <p className='access-item-subtitle text-large-medium access-typo' dangerouslySetInnerHTML={{ __html: subTitle}}></p>}
    </header>
)


export const ItemHeaderNoHtmlAccess = ({
    title,
    subTitle
}) => (
    <header className={"access-item-header" + (title || subTitle ? ' has-content' : '')}>
        {title && <h3 className="access-item-title title-xlarge-black access-typo">{title}</h3>}
        {subTitle && <p className='access-item-subtitle text-large-medium access-typo'>{subTitle}</p>}
    </header>
)

export const ItemTextAccess = ({
    text
}) => (
    text ? (
        <p className='access-item-text text-large-medium access-typo' dangerouslySetInnerHTML={{ __html: text}}></p>
    ) : ''
)